import axios from 'axios';
import { generatePath } from 'react-router-dom';

import { GENERATE_BIB_SERIES } from 'src/constants';

import { action, request, t } from 'utils';

import { errorsStore, toastStore } from 'stores';

import { GENERATE_BIB, SUPPORT_TASK_MANAGER_FORM } from '../constants';

import { mapErrorGenerateCoupons } from '../utils';

import { closeForm, mountIndex, unmountIndex } from '../actions';

class GenerateBibService {
  @request({ action: GENERATE_BIB })
  private async generateRequest(params: nil | FiltersType): Promise<any> {
    return axios.post(generatePath(GENERATE_BIB_SERIES), params);
  }

  @action({ action: GENERATE_BIB })
  async generate(params: nil | FiltersType): Promise<any> {
    const [status, response] = await this.generateRequest(params);

    if (status) {
      closeForm();
      unmountIndex();
      mountIndex();
      toastStore.show(t.staticAsString('supportTaskManager.responseGenerateBibOk'));
    } else {
      errorsStore.add(SUPPORT_TASK_MANAGER_FORM, mapErrorGenerateCoupons(response.data.errors));
    }
  }
}

export const generateBibService = new GenerateBibService();
